import { useLocale } from '@bluebeam/react-i18n';
import LanguageIcon from 'components/Icons/LanguageIcon';
import OutsideClick from 'components/OutsideClick';
import { SelectOption } from 'components/inputs/BaseSelect';
import React, { useEffect, useState } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { useLanguageOptions } from 'hooks/useLanguageOptions';

const IndexLanguage = () => {
  const [open, setOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] =
    useState<SelectOption<string>>() || '';
  const { languageCode, setLanguageCode } = useLocale();
  const { languageOptions } = useLanguageOptions();

  useEffect(() => {
    const currentLanguage = languageOptions.find(
      (language) => language.value === languageCode
    ) || { label: '', description: '', value: '' };

    setSelectedLanguage(currentLanguage);
  });

  const toggleDropdown = (evt: React.MouseEvent<HTMLElement>): void => {
    evt.stopPropagation();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleOutsideClick = (): void => {
    setOpen(false);
  };

  const handleLanguageChange = async (
    selectedOption: SelectOption
  ): Promise<void> => {
    await setLanguageCode(selectedOption.value);
    setSelectedLanguage(selectedOption);
    setOpen(false);
  };

  return (
    <Manager>
      <Reference>
        {({ ref }): React.ReactNode => (
          <div
            ref={ref}
            id="language-icon"
            className="cursor-pointer"
            onClick={toggleDropdown}
          >
            <LanguageIcon width="26px" height="26px" stroke="#2368BA" />
          </div>
        )}
      </Reference>
      <Popper placement="bottom-end">
        {({ ref, style, placement }): React.ReactNode => {
          return open ? (
            <div
              ref={ref}
              className="bgd-white"
              style={{
                ...style,
                zIndex: 2,
                top: 26,
                width: '12rem',
              }}
              data-placement={placement}
            >
              <OutsideClick onOutsideClick={handleOutsideClick}>
                <div
                  id="language-select-menu"
                  className="language-select-menu language-index-select py2"
                  style={{
                    boxShadow:
                      '0px 3px 6px rgba(0, 0, 0, 0.13), 0px 3px 6px rgba(0, 0, 0, 0.06)',
                    lineHeight: '35px',
                  }}
                >
                  {languageOptions.map((language) => (
                    <div
                      key={`language-${language.value}`}
                      style={{
                        color: `${
                          language === selectedLanguage ? '#2368BA' : ''
                        }`,
                      }}
                      className={`cursor-pointer px4 select-option ${
                        language === selectedLanguage ? 'selected' : ''
                      }`}
                      onClick={() => handleLanguageChange(language)}
                    >
                      {language.label} {language.description}
                    </div>
                  ))}
                </div>
              </OutsideClick>
            </div>
          ) : null;
        }}
      </Popper>
    </Manager>
  );
};

export default IndexLanguage;
